module.exports = __webpack_public_path__ + "static/media/BRI_WABA_LOGO_NON_BG.ad6db105.png";